"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Droppable = void 0;
const core_1 = require("@dnd-kit/core");
const react_1 = __importStar(require("react"));
const cn_1 = require("../../../../../helpers/cn");
const form_element_1 = require("./form_element");
const react_redux_1 = require("react-redux");
const document_1 = require("../../../../../reducers/slices/document/document");
const document_element_wrapper_1 = require("./document_element_wrapper");
const get_document_elements_thunk_1 = require("../../../../../reducers/slices/document/thunks/get/get_document_elements_thunk");
const update_single_element_thunk_1 = require("../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const scaleFunction_1 = require("../../../../../helpers/scaleFunction");
const grid_jpg_1 = __importDefault(require("../../../../../assets/grid.jpg"));
// Generate temporary unique ID for client-side tracking
function generateTempId() {
    return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
// Track the actual mouse position globally (shared across all Droppable instances)
// This is updated via a global mousemove listener for maximum accuracy
let globalMousePosition = { x: 0, y: 0 };
// Set up global mouse tracking on module load
if (typeof window !== 'undefined') {
    window.addEventListener('mousemove', (e) => {
        globalMousePosition = { x: e.clientX, y: e.clientY };
    });
    window.addEventListener('touchmove', (e) => {
        if (e.touches.length > 0) {
            globalMousePosition = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
    });
}
function Droppable({ index, snapToGrid }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocumentElements, selectedDocument, scrollTop } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user } = (0, react_redux_1.useSelector)((state) => state.userState);
    // Get document dimensions (from PDF or defaults)
    // Use selectedDocument as dependency to recalculate when document changes
    const docDimensions = (0, react_1.useMemo)(() => (0, scaleFunction_1.getDocumentDimensions)(selectedDocument), [selectedDocument]);
    const { isOver, setNodeRef } = (0, core_1.useDroppable)({
        id: `document-drop-area-${index}`,
        data: {
            isDocumentDropArea: true,
        },
    });
    const getDocumentElements = (loader = true) => {
        dispatch((0, get_document_elements_thunk_1.get_document_elements_thunk)({
            data: {
                document_id: selectedDocument._id,
                page: String(index),
            },
            loader: loader,
        }));
    };
    (0, react_1.useEffect)(() => {
        if (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id) {
            const scrollableDiv = document.getElementById("scrollableDiv");
            if (scrollableDiv) {
                const pageHeight = scrollableDiv.scrollHeight / selectedDocument.pages;
                const pageElement = selectedDocumentElements.filter((x) => x.page == index);
                if (pageHeight * index === scrollTop) {
                    getDocumentElements();
                }
                else if (pageHeight * index < scrollTop) {
                    if (pageElement.length === 0) {
                        getDocumentElements();
                    }
                }
            }
        }
    }, [scrollTop, selectedDocument]);
    (0, core_1.useDndMonitor)({
        onDragStart: (e) => {
            dispatch((0, document_1.setOnDrag)(true));
        },
        onDragCancel: (e) => {
            dispatch((0, document_1.setOnDrag)(false));
        },
        onDragEnd: (e) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            dispatch((0, document_1.setOnDrag)(false));
            const { active, over } = e;
            if ((over === null || over === void 0 ? void 0 : over.id) !== `document-drop-area-${index}`)
                return;
            if (!active || !over)
                return;
            const isDocumentBtnElement = (_b = (_a = active === null || active === void 0 ? void 0 : active.data) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.isDocumentBtnElement;
            const dragType = (_d = (_c = active === null || active === void 0 ? void 0 : active.data) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.dragType;
            if (isDocumentBtnElement && dragType !== "translation") {
                // GUARD: Ensure we don't process translation drags
                // Translation drags are handled by document_element_wrapper.tsx
                if (dragType === "translation") {
                    return; // Let document_element_wrapper handle this
                }
                const type = (_f = (_e = active.data) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.type;
                const tempId = generateTempId();
                let newElement = form_element_1.DocumentElements[type].construct(tempId, index);
                const thisDocument = (_g = document.getElementById(`document_${index}`)) === null || _g === void 0 ? void 0 : _g.getBoundingClientRect();
                if (!thisDocument) {
                    console.error("Failed to get document position for drag-drop");
                    return;
                }
                // Land the field exactly where the drag overlay sat at drop time.
                // Using the overlay's translated rect (active.rect.current.translated)
                // preserves the user's grab offset within the palette button — if they
                // clicked off-centre, the field stays at the off-centre position they
                // were dragging, instead of snapping to a cursor-centred position.
                // Falls back to centre-on-cursor when the rect is unavailable.
                const overlayRect = (_j = (_h = active.rect) === null || _h === void 0 ? void 0 : _h.current) === null || _j === void 0 ? void 0 : _j.translated;
                let _x, _y;
                if (overlayRect) {
                    _x = overlayRect.left - thisDocument.x;
                    _y = overlayRect.top - thisDocument.y;
                }
                else {
                    _x = globalMousePosition.x - thisDocument.x - (newElement.width || 150) / 2;
                    _y = globalMousePosition.y - thisDocument.y - (newElement.height || 50) / 2;
                }
                // Convert from screen coordinates to original document coordinates
                const pageWidth = thisDocument.width;
                const pageHeight = thisDocument.height;
                _x = (_x / pageWidth) * docDimensions.width;
                _y = (_y / pageHeight) * docDimensions.height;
                // Clamp the drop position so the field stays fully on the page.
                // Without an upper bound, fields can be dropped past the right/bottom
                // edge and end up rendering off-page in the editor and the PDF.
                const fieldW = newElement.width || 150;
                const fieldH = newElement.height || 50;
                const clampedX = Math.max(0, Math.min(_x, docDimensions.width - fieldW));
                const clampedY = Math.max(0, Math.min(_y, docDimensions.height - fieldH));
                newElement = Object.assign(Object.assign({}, newElement), { page: index, extra_attributes: Object.assign(Object.assign({}, newElement.extra_attributes), { x: clampedX, y: clampedY }) });
                // Auto-assign user to signable fields when "I'm the only signer" is enabled
                const signableFields = ["Signature", "Initials", "TextField", "Date", "Checkbox", "Radio Buttons"];
                if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.only_signer) && user && signableFields.includes(type)) {
                    newElement = Object.assign(Object.assign({}, newElement), { extra_attributes: Object.assign(Object.assign({}, newElement.extra_attributes), { user: {
                                _id: user._id,
                                email: user.email,
                                name: user.name,
                                surname: user.surname,
                            }, user_id: user._id, restricted: true }) });
                }
                // Position is tracked globally, no cleanup needed
                // No need to guard against multiple temp IDs - each is unique
                let thisPage = index;
                dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                    newElement: true,
                    data: {
                        document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                        payload: Object.assign(Object.assign({}, newElement), { page: thisPage }),
                    },
                }));
            }
        },
    });
    const backgroundGridStyle = {
        backgroundImage: `url(${grid_jpg_1.default})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    };
    return (react_1.default.createElement("div", { ref: setNodeRef, id: `document_${index}`, 
        //  style={{ position: "relative" }}
        style: Object.assign({ width: `${(0, scaleFunction_1.scaleFunction)(docDimensions.width, docDimensions.width)}px`, minHeight: `${(0, scaleFunction_1.scaleFunction)(docDimensions.height, docDimensions.width)}px`, height: `${(0, scaleFunction_1.scaleFunction)(docDimensions.height, docDimensions.width)}px` }, backgroundGridStyle), className: (0, cn_1.cn)(`bg-white m-auto shadow-md flex flex-col flex-grow item-center justify-start flex-1 relative p-1`, isOver && "ring-2 ring-primary/20") },
        selectedDocumentElements.length == 0 && !isOver && (react_1.default.createElement("p", { className: "text-3xl font-bold text-muted-foreground flex flex-grow items-center justify-center" }, "Drop here")),
        selectedDocumentElements &&
            selectedDocumentElements.length > 0 &&
            (() => {
                const pageElements = selectedDocumentElements.filter((elem) => (elem === null || elem === void 0 ? void 0 : elem.page) == index);
                // Separate page backgrounds (PDF images) from other elements
                // Page backgrounds are Text elements containing only an image
                const isPageBackground = (el) => {
                    var _a;
                    const text = ((_a = el === null || el === void 0 ? void 0 : el.extra_attributes) === null || _a === void 0 ? void 0 : _a.text) || "";
                    return el.type === "Text" && (text.trim().startsWith("<img") ||
                        (text.trim().startsWith("<p>") && text.includes("<img") && !text.replace(/<img[^>]*>/g, "").replace(/<\/?p>/g, "").trim()));
                };
                const backgrounds = pageElements.filter(isPageBackground);
                const fields = pageElements.filter((el) => !isPageBackground(el));
                // Render backgrounds first (behind), then fields on top
                return [
                    ...backgrounds.map((element) => react_1.default.createElement(document_element_wrapper_1.DocumentElementWrapper, { key: element._id, element: element, snapToGrid: snapToGrid })),
                    ...fields
                        .sort((a, b) => { var _a, _b; return (((_a = a.extra_attributes) === null || _a === void 0 ? void 0 : _a.y) || 0) - (((_b = b.extra_attributes) === null || _b === void 0 ? void 0 : _b.y) || 0); })
                        .map((element) => react_1.default.createElement(document_element_wrapper_1.DocumentElementWrapper, { key: element._id, element: element, snapToGrid: snapToGrid })),
                ];
            })()));
}
exports.Droppable = Droppable;
